import { pickupLabels, pickupTime } from "@/lib/pickups";
import type { Order } from "@/types/cart";

export function PickupSummary({ order }: { order: Pick<Order, "fulfillmentMethod" | "pickupLocation" | "pickupStatus" | "pickupStartsAt" | "pickupEndsAt" | "pickupNote"> }) {
  if (order.fulfillmentMethod !== "PICKUP") return null;
  return <div className="space-y-1 text-sm">
    <p>{order.pickupLocation || "Store pickup"}</p>
    {order.pickupStatus && <p className="font-semibold">{pickupLabels[order.pickupStatus]}</p>}
    {order.pickupStartsAt && <p>{pickupTime(order.pickupStartsAt)}{order.pickupEndsAt ? ` - ${pickupTime(order.pickupEndsAt)}` : ""}</p>}
    {order.pickupStatus === "REQUESTED" && <p>This time is a request and has not been confirmed.</p>}
    {order.pickupNote && <p className="break-words">{order.pickupNote}</p>}
  </div>;
}
